module.exports = __webpack_public_path__ + "static/contet-blocks-tracking-rough-26b08a1c7ffc519cac5fe832adf25f25.jpg";